import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxFormlyModule } from './modules/formly/formly.module';
import { NgxFormsService } from './services/ngx-forms.service';

import { NgxFormComponent } from './components/ngx-form.component';
import { NgxFormButtonsComponent } from './components/ngx-form-buttons.component';
import { NgxFormFieldsComponent } from './components/ngx-form-fields.component';
import { NgxFormHeaderComponent } from './components/ngx-form-header.component';
export class NgxFormsModule {
/**
 * @return {?}
 */
static forRoot(): ModuleWithProviders {
    return {
      ngModule: NgxFormsModule,
      providers: [NgxFormsService],
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxFormlyModule],
  declarations: [NgxFormComponent, NgxFormButtonsComponent, NgxFormFieldsComponent, NgxFormHeaderComponent],
  exports: [NgxFormComponent, NgxFormButtonsComponent, NgxFormFieldsComponent, NgxFormHeaderComponent],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgxFormsModule_tsickle_Closure_declarations() {
/** @type {?} */
NgxFormsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxFormsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
